<template>
  <div id="emailTemplateModule">
    <div id="list" v-if="list">
      <v-card-title>
        <v-select 
          class="filter_left"
          v-model="filterLayout" 
          label="Filter by Layout"
          :items="[...[{ name: 'All', value: 'All'}], ...layouts]"
          item-value="value"
          item-text="name"
          @change="filterByLayout">
        </v-select>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card class="mt-3">
        <v-data-table
          disable-initial-sort
          :headers="headers"
          :items="templates"
          :search="search"
          class="pf-data-table"
          ref="sortableTable"
          :pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.subject }}</td>
              <td>{{ ['commonTemplate', 'childFinderLayout'].indexOf(props.item.templateName) > -1 ? '--' : layoutTexts[props.item.layout || 'commonTemplate'] }}</td>
              <td>{{ props.item.active === true ? 'Active' : 'Inactive' }}</td>
              <td align="right">
                <v-btn icon class="ma-0" @click="editItem(props.item)">
                  <v-icon size="22" color="grey darken-2">edit</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div id="emailTemplateEdit" v-if="!list">
      <v-flex md6 pb-4 style="min-height:70px;">
        <v-btn fab left class="ml-3 pf-btn-fab" @click="backToList()">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
      <div>
        <v-form ref="emailTemplateEdit">
          <v-container class="-border">
            <v-layout wrap>
              <v-flex xs12 class="button-container pr-3 text-xs-right">
                <div class="d-inline-flex" v-if="selectedData">
                  <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false;list = true">
                    <v-icon size="16" class="pr-1">cancel</v-icon>
                    <div>Cancel</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save" @click="save">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Save</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!commonTempSub">
                  <v-flex xs12 md7>
                      <v-switch
                          v-model="editableTemplate.active"
                           @change="changedData"
                          label="Active"
                          class="pr-4 pl-4">
                      </v-switch>
                  </v-flex>
            </v-layout>
            <v-layout v-if="!commonTempSub">
              <v-flex class="xs12 sm6 md7">
                  <v-combobox
                    v-model="messageTo"
                    @change="selectedRecipient"
                    :items="recipientList"
                    :item-text="item => `${item.name} - (${item.role})`"
                    label="To"
                    hide-no-data
                    small-chips
                    return-object
                    multiple
                    deletable-chips
                    placeholder="Search by Name / Nickname"
                    hint="Select default recipients, message groups and admins"
                    persistent-hint
                    id="defaultRecipientSearch"
                    class="pr-4 pl-4 required">
                  </v-combobox>
              </v-flex>
            </v-layout>
            <v-layout v-if="!commonTempSub">
              <v-flex xs12 md7>
                <v-combobox class="pr-4 pl-4 hide_dropdown_icon" :rules="[rulesCcBcc.multipleEmail]" @change="changedData" v-model="editableTemplate.cc" label="CC" hint="emails - hit enter to add new" multiple deletable-chips small-chips></v-combobox>
              </v-flex>
            </v-layout>
            <v-layout v-if="!commonTempSub">
              <v-flex xs12 md7>
                <v-combobox class="pr-4 pl-4 hide_dropdown_icon" :rules="[rulesCcBcc.multipleEmail]" @change="changedData" v-model="editableTemplate.bcc" label="BCC" hint="emails - hit enter to add new" multiple deletable-chips small-chips></v-combobox>
              </v-flex>
            </v-layout>
            <v-layout wrap row v-if="!commonTempSub">
              <v-flex xs12 md7>
                <v-text-field
                  label="From Address"
                  v-model.trim="editableTemplate.from"
                  class="required pr-4 pl-4"
                  :rules="rules"
                  @input="changedData"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout v-if="!commonTempSub">
              <v-flex xs12 md7>
                <v-text-field
                  label="Subject"
                  v-model.trim="editableTemplate.subject"
                  class="required pr-4 pl-4"
                  :rules="rules"
                  @input="changedData"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout v-if="!commonTempSub">
              <v-flex xs12 md7>
                <v-select
                  label="Layout"
                  :items="layouts"
                  item-text="name"
                  item-value="value"
                  v-model.trim="editableTemplate.layout"
                  class="required pr-4 pl-4"
                  :rules="rules"
                  @input="changedData"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <div id="pageEditor">
                  <v-container grid-list-xl fluid>
                    <v-layout row wrap>
                      <v-flex sm12>
                        <!-- <quill-editor :options="editorOption" v-model="editableTemplate.text" @input="changedData"></quill-editor> -->
                        <editor :options="editorOption" :init="init" :api-key="apikey" v-model="editableTemplate.text" @input="changedData" />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-flex>
            </v-layout>
            <v-layout wrap class="v-card ml-4 mr-4 mt-1" row>
              <v-flex xs12 md6>
                  <v-list subheader>
                  <v-subheader class="pf-text-teal">
                    Variables
                  </v-subheader>
                  <v-list-tile v-for="(variable, i) of variableList.slice(0, 6)" :key="i">
                    <v-list-tile-content>
                    <v-list-tile-title :class="disabledParms.indexOf(variable) !== -1 ? 'textCopyDisabled grey--text': 'pointer'">
                      {{ getVariables(variable) }} <span class="textCopyDisabled" :class="disabledParms.indexOf(variable) !== -1 ? '': 'light-blue--text'"> - {{ config.email_template.description[variable] }}</span>
                    </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0" :disabled="disabledParms.indexOf(variable) !== -1 ? true : false">
                        <v-icon
                        v-clipboard:copy="`{{ ${variable} }}`"
                        :ref="`var${i}`" size="22" color="#7ac142">file_copy</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                  </v-list>
              </v-flex>
              <v-flex xs12 md6 v-if="variableList.length > 6">
                  <v-list subheader>
                  <v-subheader v-if="$vuetify.breakpoint.mdAndUp" class="pf-text-teal visibility">
                    Variables
                  </v-subheader>
                  <v-list-tile v-for="(variable, i) of variableList.slice(6)" :key="i">
                    <v-list-tile-content>
                    <v-list-tile-title :class="disabledParms.indexOf(variable) !== -1 ? 'textCopyDisabled grey--text': 'pointer'">
                      {{ getVariables(variable) }} <span class="textCopyDisabled" :class="disabledParms.indexOf(variable) !== -1 ? '': 'light-blue--text'"> - {{ config.email_template.description[variable] }}</span>
                    </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0" :disabled="disabledParms.indexOf(variable) !== -1 ? true : false">
                        <v-icon
                        v-clipboard:copy="`{{ ${variable} }}`"
                        :ref="`var${i}`" size="22" color="#7ac142">file_copy</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                  </v-list>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 class="button-container pr-3 text-xs-right">
                <div class="d-inline-flex" v-if="selectedData">
                  <v-btn class="pf-btn pf-btn-cancel" @click="selectedData = false;list = true">
                    <v-icon size="16" class="pr-1">cancel</v-icon>
                    <div>Cancel</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save" @click="save">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Save</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
    </div>
    <v-snackbar
      :timeout="3000"
      right
      color="green"
      v-model="snackbarShow"
    >
      variable copied to clipboard
      <v-btn
        dark
        flat
        @click="snackbarShow = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
/* global session store config */

import Vue from 'vue';
import swal from 'sweetalert2';
import { getCollection, remove, update, uploadFile } from '../../helpers/helpers';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import { mapGetters } from 'vuex';
import VueClipboard from 'vue-clipboard2';
import Editor from '@tinymce/tinymce-vue';
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

export default {
  name: 'EmailTemplate',
  components: {
    'editor': Editor
  },
  data: () => ({
    editorOption: {
      'initial-value': 'Add text here..',
    },
    apikey: config.tinymceEditorKey,
    config: config,
    commonTempSub: false,
    init: {
      height: 500,
      selector: 'pageEditor#full-featured-non-premium',
      menubar: true,
      plugins: ['advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount emoticons'],
      toolbar: 'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | pagebreak | charmap emoticons | preview | insertfile image media template link anchor codesample | ltr rtl'
    },
    variableList: ['family', 'date', 'agency'],
    disabledParms: [],
    snackbarShow: false,
    editIndex: -1,
    list: true,
    search: '',
    headers: [
      { text: 'Subject', value: 'subject', align: 'left' },
      { text: 'Layout', value: 'Layout', align: 'left' },
      { text: 'Active', value: 'active', align: 'left' },
      { text: '', sortable: false, width: '50px' }
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage
    },
    defaultValues: [
      {
        type: 'default',
        id: 'Default Admin',
        name: 'Default Admin',
        role: 'default'
      },
      {
        type: 'default',
        id: 'Default Agency',
        name: 'Default Agency',
        role: 'default'
      },
      {
        type: 'default',
        id: 'Default Family',
        name: 'Default Family',
        role: 'default'
      },
      {
        type: 'default',
        id: 'Default Writer',
        name: 'Default Writer',
        role: 'default'
      },
    ],
    defaultValuesCopy: [],
    selectedData: false,
    editableTemplate: {},
    selectedIds: [],
    rules: [v => !!v.trim() || 'Field is required'],
    rulesCcBcc: {
      multipleEmail: (v) => v === undefined || v.length === 0 || /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(v) || 'Please enter valid email address'
    },
    adminList: [],
    messageGroupList: [],
    recipientList: [],
    messageTo: [],
    messageRecipients: [],
    query: {
      family: ''
    },
    templates: [],
    layouts: [
      { name: 'Parentfinder', value: 'commonTemplate' },
      { name: 'Childfinder', value: 'childFinderLayout' }
    ],
    layoutTexts: {
      commonTemplate: 'Parentfinder',
      childFinderLayout: 'Childfinder'
    },
    filterLayout: 'All'
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    MessageGroup: {
      get () {
        return store.state.MessageGroup;
      },
      set (value) {
        store.commit('setMessageGroup', value);
      }
    },
    EmailTemplate: {
      get () {
        return store.state.EmailTemplate;
      },
      set (value) {
        store.commit('setEmailTemplate', value);
      }
    }
  },
  async created () {
    this.getEmailTempaltes();
    await this.getAdminsList();
    await this.initializeMessageGroups();
  },
  methods: {
    getVariables (variable) {
      if (variable.length) {
        return `{{ ${variable} }}`;
      }
    },
    async initializeMessageGroups () {
      if (!this.MessageGroup.length) {
        let { error, data } = await getCollection('MessageGroup', true, 0);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load message groups'
          };
        } else {
          if (data.length > 0) {
            this.MessageGroup = data;
            this.formatMessageList(data);
          }
        }
      }
    },
    async formatMessageList (filteredList) {
      if (filteredList.length) {
        filteredList.forEach(item => {
          let obj = {
            type: 'group',
            id: item.id,
            name: item.name,
            role: 'group'
          };
          this.messageGroupList.push(obj);
        });
      }
    },
    setRecipientList () {
      this.messageTo = [];
      this.selectedIds = [];
      this.messageRecipients = [];
      if (this.editableTemplate) {
        let obj = {};
        if (this.editableTemplate.human && this.editableTemplate.human.length) {
          this.editableTemplate.human.forEach(human => {
            obj = {
              type: 'human',
              id: human.id,
              name: human.name || (human.first_name + ' ' + human.last_name),
              role: 'admin'
            };
            this.messageTo.push(obj);
            this.selectedIds.push(obj.id);
            this.messageRecipients.push(obj);
          });
        }
        if (this.editableTemplate.group && this.editableTemplate.group.length) {
          this.editableTemplate.group.forEach(to => {
            obj = {
              type: 'group',
              id: to.id,
              name: to.name,
              role: 'group'
            };
            this.messageTo.push(obj);
            this.selectedIds.push(obj.id);
            this.messageRecipients.push(obj);
          });
        }
        if (this.editableTemplate.to && this.editableTemplate.to.length) {
          this.editableTemplate.to.forEach(to => {
            obj = {
              type: 'default',
              id: to,
              name: to,
              role: 'default'
            };
            this.messageTo.push(obj);
            this.selectedIds.push(obj.id);
            this.messageRecipients.push(obj);
          });
        }
        if (this.editableTemplate.to_email && this.editableTemplate.to_email.length) {
          this.editableTemplate.to_email.forEach(to => {
            this.messageTo.push(to);
          });
        }
      }
    },
    async getEmailTempaltes (force = false) {
      if (!this.EmailTemplate.length || force) {
        let entity = `EmailTemplate`;
        let populate = [{ path: 'human', select: 'first_name last_name' }, { path: 'group', select: 'name' }];
        let { error, data } = await getCollection(entity, true, 0, populate);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.EmailTemplate = data;
            this.templates = JSON.parse(JSON.stringify(data));
          }
        }
      } else {
        this.templates = this.EmailTemplate;
      }
    },
    filterByLayout () {
      if (this.filterLayout === 'All') {
        this.templates = this.EmailTemplate;
      } else {
        this.templates = this.EmailTemplate.filter(x => (this.filterLayout === 'commonTemplate' && !x.layout) || x.layout === this.filterLayout);
      }
    },
    changedData () {
      this.selectedData = true;
    },
    selectedRecipient () {
      this.selectedIds = [];
      this.messageRecipients = [];
      this.changedData();
      this.messageTo.forEach(to => {
        this.selectedIds.push(to.id);
        if (this.messageRecipients.findIndex(x => x.id === to.id) === -1) {
          this.messageRecipients.push(to);
        }
      });
      this.selectedIds = [...new Set(this.selectedIds)];
    },
    async getAdminsList () {
      let where = { is_admin: true };
      let populate = [{ 'path': 'human', 'select': 'id first_name last_name' }];
      let attributes = 'name,nickname';
      let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to load client list'
        };
      } else {
        if (data.length > 0) {
          this.formatRecipients(data);
        }
      }
    },
    formatRecipients (data) {
      if (data.length) {
        data.forEach(row => {
          if (typeof row.human[0].id !== 'undefined') {
            let entry = {
              type: 'human',
              id: row.human[0].id,
              name: row.name ? row.name : (row.human[0].first_name + ' ' + row.human[0].last_name),
              role: 'admin'
            };
            if (row.nickname) {
              entry.name = `${entry.name} / ${row.nickname}`;
            }
            this.adminList.push(entry);
          }
        });
      }
    },
    async editItem (item) {
      this.commonTempSub = false;
      this.selectedData = false;
      this.editIndex = this.EmailTemplate.indexOf(item);
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.list = false;
      this.editableTemplate = JSON.parse(JSON.stringify(item));
      if (['commonTemplate', 'childFinderLayout'].indexOf(this.editableTemplate.templateName) > -1) {
        this.commonTempSub = true;
      }
      this.defaultValuesCopy = JSON.parse(JSON.stringify(this.defaultValues));
      if (this.editableTemplate.default_list.length === 1) {
        this.defaultValuesCopy.splice(1, 2);
      } else if ((this.editableTemplate.default_list.indexOf('Default Agency') === -1)) {
        this.defaultValuesCopy.splice(1, 1);
      } else if ((this.editableTemplate.default_list.indexOf('Default Family') === -1)) {
        this.defaultValuesCopy.splice(2, 1);
      }
      if (!this.editableTemplate.layout) {
        this.editableTemplate.layout = 'commonTemplate';
      }
      this.recipientList = [];
      await this.formatMessageList(this.MessageGroup);
      this.recipientList = [...this.defaultValuesCopy, ...this.adminList, ...this.messageGroupList];
      this.setRecipientList();
      this.variableList = [];
      this.disabledParms = [];
      this.variableList = this.editableTemplate.params;
      this.disabledParms = this.editableTemplate.disabled_params;
    },
    backToList () {
      this.messageTo = [];
      this.messageRecipients = [];
      window.getApp.$emit('pageSubHeader', '');
      this.list = true;
      this.editIndex = -1;
    },
    async save () {
      if (this.editableTemplate.text === '' || this.editableTemplate.text === '<p> </p>') {
        swal.fire({
          type: 'warning',
          title: 'Content is required.',
          text: 'Please add content before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      }
      let emailCount = this.messageTo.filter(email => typeof email === 'string').length;
      let validEmails = this.messageTo.filter(email => typeof email === 'string' && /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(email));
      if (emailCount === validEmails.length) {
        this.editableTemplate.to_email = validEmails;
      } else {
        swal.fire({
          type: 'warning',
          title: 'We have entered an invalid email',
          text: 'Please add valid emails under To field',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      }
      this.editableTemplate.to = Array.from(this.messageRecipients.filter(x => x.role === 'default'), x => x.id);
      this.editableTemplate.human = Array.from(this.messageRecipients.filter(x => x.role === 'admin'), x => x.id);
      this.editableTemplate.group = Array.from(this.messageRecipients.filter(x => x.role === 'group'), x => x.id);
      if (!this.commonTempSub && (!this.editableTemplate.to.length && !this.editableTemplate.human.length && !this.editableTemplate.group.length && !this.editableTemplate.to_email.length)) {
        swal.fire({
          type: 'warning',
          title: 'recipient required.',
          text: 'Please add atleast one recipients under To field',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      }
      this.editableTemplate.text = this.editableTemplate.text.replace(/&nbsp;/gi, ' ');
      if (this.$refs.emailTemplateEdit.validate()) {
        this.selectedData = false;
        // Add the default recipients
        let { error, data } = await update('EmailTemplate', this.editableTemplate, this.editableTemplate.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.getEmailTempaltes(true);
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Email Template updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              this.list = true;
              this.messageTo = [];
              this.messageRecipients = [];
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    }
  }
};
</script>
<style scoped>
#emailTemplateModule >>> .accent--text {
    color: #019d8c !important;
    caret-color: #019d8c !important;
}

#emailTemplateModule >>> .v-input__slot {
    flex-direction: row-reverse;
}

#emailTemplateModule >>> .v-input__slot .v-label{
    margin-right: 10px !important;
}

#emailTemplateModule >>> .v-list .center {
  align-items: flex-end !important;
}

#emailTemplateModule >>> .hide_dropdown_icon .v-input__append-inner {
  display: none;
}

#emailTemplateModule >>> .textCopyDisabled {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#emailTemplateModule >>> .pointer {
  cursor: pointer;
}

#emailTemplateModule >>> .visibility {
  visibility: hidden;
}

#emailTemplateModule >>> .v-list__tile {
  height: 32px!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/EmailTemplate/list.vue